<template>
  <div class="search">
    <div class="searchRight">
      <!-- <span><svg-icon class-name="international-icon" icon-class="frame131" /> 奥铃</span> -->
      <el-dropdown trigger="click" class="international">
        <div v-if="!visitorCode" class="brand">
          <svg-icon class-name="international-icon" icon-class="frame131" />{{ visitorCode | codeFilter }} <i class="el-icon-arrow-down" />
        </div>
        <div v-else class="brand">
          <svg-icon class-name="international-icon" icon-class="frame131" />北汽重卡<i class="el-icon-arrow-down" />
        </div>
        <el-dropdown-menu>
          <el-dropdown-item>
            北汽重卡
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <span @click="goCart"><i class="el-icon-shopping-cart-2" />购物车</span>       -->
      <span @click="goCart"><svg-icon icon-class="frame134" class="iconClass" />购物车</span>
      <span> <lang-select class="right-menu-item hover-effect" /></span>
      <span><i class="el-icon-bell" /></span>      
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span v-if="name === 'visitor'" class="el-breadcrumb__inner">
            <i class="el-icon-user" />{{ visitoName }}<i class="el-icon-arrow-down" />
          </span>
          <span v-else class="el-breadcrumb__inner">
            <i class="el-icon-user" />{{ name }}<i class="el-icon-arrow-down" />
          </span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import LangSelect from '@/components/LangSelect'
import { setWaterMark } from '@/api/watermark'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'

const codeEnum = { 123: '北汽重卡' }

  export default {
     components: {
       LangSelect
     },
    filters: {
      codeFilter(type) {
        return codeEnum[type]
      }
    },
    data() {
      return {
        form: {
          vin: ''
        },
        userName: this.$store.getters.name,
        visitorCode: localStorage.getItem('visitorCode'),
        visitoName: localStorage.getItem('visitoName'),
        jwtHeader: { token: Cookies.get('Admin-Token') }
      };
    },
     computed: {
      ...mapGetters(["sidebar", "avatar", "device", "name"])
    },
    mounted() {
    setWaterMark('', this.userName)
  },
    methods: {
      goCart() {
          this.$router.push({ path: '../epc/cart' })
      },
      // goSearchParts() {
      //     // this.$router.push({ path: '../epc/searchParts' })
      //     console.log('111');
      // },
       async logout() {
        await this.$store.dispatch("user/logout");
        // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        window.location.href = "about:blank"; window.close();
        // window.location.href = window.close();
      }
    }
  };
</script>

<style lang="scss" scoped>
.search{
  ul{
    li{
      float: left;
      width: 165px;
      margin-right: 10px;
      font-size: 12px;
    }
  }
  .searchRight{
    position: absolute;
    right: 10px;
    top: 9px;
    .brand{
      cursor: pointer;
      font-size: 12px;
      color: #333;
      .svg-icon{
        margin-right: 4px;
        font-size: 18px !important;
        color: #333 !important;
      }
    }
    span{
      font-size: 12px;
      padding: 0 15px;
      color: #333;
      cursor: pointer;
      .el-icon-user{
        padding-right: 5px;
        font-size: 16px;
      }
      .svg-icon{
        color: #333 !important;
      }
      .iconClass{
         margin-right: 4px;
         font-size: 16px !important;
      }
      .el-icon-shopping-cart-2{
        padding-right: 5px;
        font-size: 16px;
      }
      .el-icon-bell{
         font-size: 16px;
         color: #333;
      }
    }
  }
}
</style>
